"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ServerError;
var _data = require("../../stores/data");
require("./server-error.less");
var _jsxRuntime = require("react/jsx-runtime");
function ServerError() {
  var _useData = (0, _data.useData)(),
    error = _useData.error;
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "server-error",
      children: error
    });
  }
}